// extracted by mini-css-extract-plugin
export default {"container":"DeleteButton_container__KaaUy"};